(function initialiseMuscleMintFreeToolsAsset() {
if (window.MuscleMintFreeToolsAssetLoaded) return;
window.MuscleMintFreeToolsAssetLoaded = true;

const toolChoice = (id, prompt, options, required = true) => ({ id, prompt, options, required, type: 'choice' });
const toolText = (id, prompt, required = false, inputType = 'text') => ({ id, prompt, required, type: inputType });

const freeToolDefinitions = {
  'muscle-assessment': {
    name: 'Muscle Soreness Assessment',
    questions: [
      toolText('duration', 'How long have you noticed the soreness?', true),
      toolText('occupation', 'What kind of work or daily routine do you have?', true),
      toolText('tried', 'What have you already tried?'),
      toolChoice('outcome', 'What would be most useful today?', [['pain-relief', 'Make the area feel more comfortable'], ['performance', 'Plan around training or activity'], ['feel-normal-again', 'Get back to feeling normal']]),
      toolChoice('onset', 'When did you first notice it?', [['during-exercise', 'During exercise or movement'], ['6-12h', 'About 6 to 12 hours later'], ['24-48h', 'About 24 to 48 hours later'], ['gradual', 'It appeared gradually']]),
      toolChoice('trigger', 'What seems most closely connected?', [['intense-workout', 'An intense workout'], ['new-exercise', 'A new exercise or movement'], ['long-desk-day', 'A long desk or work day'], ['sleep-position', 'A sleep position'], ['not-sure', 'I am not sure']]),
      toolChoice('character', 'Which description is closest?', [['tender-touch', 'Tender to touch'], ['stiff-tight', 'Stiff or tight'], ['dull-ache', 'A dull ache'], ['sharp-pain', 'Sharp pain'], ['heavy-fatigue', 'Heavy or fatigued']]),
      toolChoice('area', 'Where do you notice it most?', [['legs', 'Legs'], ['lower-back', 'Lower back'], ['neck-shoulders', 'Neck or shoulders'], ['arms-upper-body', 'Arms or upper body'], ['multiple-areas', 'Multiple areas']]),
      toolChoice('intensity', 'How intense does it feel?', [['1-3', 'Mild (1 to 3)'], ['4-6', 'Moderate (4 to 6)'], ['7-8', 'Strong (7 to 8)'], ['9-10', 'Severe (9 to 10)']])
    ]
  },
  'doms-calculator': {
    name: 'DOMS Recovery Calculator',
    questions: [
      toolText('duration', 'How long has the soreness been present?', true),
      toolChoice('training_type', 'What kind of training came before it?', [['strength', 'Strength training'], ['hiit', 'HIIT'], ['endurance', 'Endurance training'], ['sport', 'Sport'], ['new-routine', 'A new routine']]),
      toolText('occupation', 'What kind of work or daily routine do you have?'),
      toolText('tried', 'What have you already tried?'),
      toolChoice('outcome', 'What would be most useful today?', [['pain-relief', 'Make the area feel more comfortable'], ['performance', 'Plan around training or activity'], ['feel-normal-again', 'Get back to feeling normal']]),
      toolChoice('doms_pattern', 'Which pattern is closest?', [['tightness', 'Tightness'], ['tenderness', 'Tenderness'], ['dull-ache', 'A dull ache'], ['movement-pain', 'Pain with movement']]),
      toolChoice('onset', 'When did it become noticeable?', [['same-day', 'The same day'], ['24h', 'About 24 hours later'], ['48h', 'About 48 hours later'], ['72h-plus', '72 hours or more later']]),
      toolChoice('affected_area', 'Which area is most affected?', [['legs', 'Legs'], ['upper-body', 'Upper body'], ['core', 'Core'], ['full-body', 'Full body']]),
      toolText('last_trained_date', 'When did you last train?', true, 'date'),
      toolChoice('intensity', 'How intense does it feel?', [['1-3', 'Mild (1 to 3)'], ['4-6', 'Moderate (4 to 6)'], ['7-8', 'Strong (7 to 8)'], ['9-10', 'Severe (9 to 10)']]),
      toolChoice('sleep_quality', 'How has your recent sleep felt?', [['poor', 'Poor'], ['moderate', 'Moderate'], ['good', 'Good'], ['excellent', 'Excellent']])
    ]
  },
  'posture-check': {
    name: 'Desk Worker Posture Check',
    questions: [
      toolText('duration', 'How long has this workday discomfort been present?', true),
      toolChoice('hours_seated', 'How many hours do you usually sit each day?', [['1-3', '1 to 3 hours'], ['4-6', '4 to 6 hours'], ['7-8', '7 to 8 hours'], ['9+', '9 hours or more']]),
      toolChoice('has_headaches', 'Do headaches form part of the pattern?', [['yes', 'Yes'], ['sometimes', 'Sometimes'], ['no', 'No']]),
      toolText('occupation', 'What kind of work do you do?'),
      toolText('tried', 'What have you already tried?'),
      toolChoice('outcome', 'What would be most useful today?', [['pain-relief', 'Make the area feel more comfortable'], ['performance', 'Plan around work or activity'], ['feel-normal-again', 'Get back to feeling normal']]),
      toolChoice('pain_area', 'Where do you notice it most?', [['neck', 'Neck'], ['lower-back', 'Lower back'], ['mid-back', 'Mid back'], ['wrists-hands', 'Wrists or hands'], ['hips-glutes', 'Hips or glutes'], ['multiple', 'Multiple areas']]),
      toolChoice('sitting_style', 'Which setup is closest to yours?', [['slumped', 'Slumped sitting'], ['cross-legs', 'Sitting cross-legged'], ['no-lumbar', 'Little or no lower-back support'], ['elevated-screen', 'An elevated screen'], ['standing-desk', 'A standing desk'], ['not-sure', 'I am not sure']]),
      toolChoice('frequency', 'When do you notice it?', [['constant', 'Most of the time'], ['end-of-day', 'At the end of the day'], ['morning', 'In the morning'], ['after-screen', 'After screen work'], ['occasional', 'Occasionally']]),
      toolChoice('intensity', 'How intense does it feel?', [['1-3', 'Mild (1 to 3)'], ['4-6', 'Moderate (4 to 6)'], ['7-8', 'Strong (7 to 8)'], ['9-10', 'Severe (9 to 10)']])
    ]
  },
  'recovery-planner': {
    name: 'Workout Recovery Planner',
    questions: [
      toolChoice('training_days_per_week', 'How many days do you train in a typical week?', [['1-2', '1 to 2 days'], ['3', '3 days'], ['4', '4 days'], ['5', '5 days'], ['6-7', '6 to 7 days']]),
      toolText('duration', 'How long have you followed this routine?', true),
      toolText('training_goals', 'What are you training towards?'),
      toolText('occupation', 'What kind of work or daily routine do you have?'),
      toolText('tried', 'What recovery approaches have you already tried?'),
      toolChoice('outcome', 'What would be most useful today?', [['pain-relief', 'Make recovery feel more manageable'], ['performance', 'Plan around performance'], ['feel-normal-again', 'Get back to feeling normal']]),
      toolChoice('training_split', 'Which training structure is closest?', [['bro-split', 'Body-part split'], ['push-pull', 'Push/pull split'], ['full-body', 'Full-body training'], ['crossfit', 'CrossFit'], ['cardio', 'Cardio'], ['sport', 'Sport'], ['no-routine', 'No set routine']]),
      toolChoice('recovery_challenge', 'What is the main recovery challenge?', [['cant-sleep', 'Sleep is difficult'], ['always-sore', 'Often feeling sore'], ['plateau', 'A training plateau'], ['injury-risk', 'Managing injury risk'], ['motivation', 'Motivation'], ['acute-pain', 'Acute pain']]),
      toolChoice('experience_level', 'How would you describe your experience?', [['beginner', 'Beginner'], ['intermediate', 'Intermediate'], ['advanced', 'Advanced'], ['athlete', 'Athlete']]),
      toolChoice('sleep_quality', 'How has your recent sleep felt?', [['poor', 'Poor'], ['moderate', 'Moderate'], ['good', 'Good'], ['excellent', 'Excellent']])
    ]
  },
  'suitability-check': {
    name: 'Suitability and Safe Use Check',
    ai: false,
    routes: ['good-to-try', 'check-first', 'not-suitable'],
    disclaimer: 'This is a cosmetic product. It creates a cooling sensation on the skin. It is not a medicine and it does not treat anything.',
    questions: [
      toolChoice('use_area', 'Where are you planning to use it?', [['legs-back-shoulders', 'Legs, back or shoulders'], ['hands-arms', 'Hands or arms'], ['feet', 'Feet'], ['face-neck-eyes', 'Face, neck or anywhere near the eyes']]),
      toolChoice('skin_condition', 'Is the skin there broken, cracked, sunburned or irritated?', [['no', 'No'], ['yes', 'Yes'], ['not-sure', 'I am not sure']]),
      toolChoice('pregnant_breastfeeding', 'Are you pregnant or breastfeeding?', [['no', 'No'], ['yes', 'Yes']]),
      toolChoice('age_16_plus', 'Is the person using it 16 or over?', [['yes', 'Yes'], ['no', 'No']]),
      toolChoice('allergy_history', 'Have you ever reacted to menthol, peppermint, eucalyptus, or to limonene or linalool in cosmetics?', [['no', 'No'], ['yes', 'Yes'], ['not-sure', 'I am not sure']]),
      toolChoice('other_products', 'Will you be using other creams, gels or patches on the same area?', [['no', 'No'], ['yes', 'Yes']]),
      toolChoice('used_menthol_before', 'Have you used a strong menthol product before?', [['yes', 'Yes'], ['no', 'No']])
    ]
  }
};

const isLocalToolPreview = () => ['localhost', '127.0.0.1'].includes(window.location.hostname);

function createToolElement(tag, className, text) {
  const element = document.createElement(tag);
  if (className) element.className = className;
  if (text !== undefined) element.textContent = text;
  return element;
}

function answerDisplay(question, value) {
  return question.options?.find(([optionValue]) => optionValue === value)?.[1] || value;
}

function toolAnswerSummary(definition, answers) {
  return definition.questions
    .filter((question) => answers[question.id])
    .map((question) => [question.prompt, answerDisplay(question, answers[question.id])]);
}

function suitabilityRouteAndReasons(answers) {
  const notSuitable = [
    answers.use_area === 'face-neck-eyes' && 'Muscle Mint is not for the face, neck or any area near the eyes.',
    answers.skin_condition === 'yes' && 'It is not for broken, cracked, sunburned or irritated skin.',
    answers.age_16_plus === 'no' && 'The safety assessment for this product covers adults aged 16 and over.',
    answers.allergy_history === 'yes' && 'You have reacted before to an ingredient of this type.'
  ].filter(Boolean);
  if (notSuitable.length) return { route: 'not-suitable', reasons: notSuitable };
  const checkFirst = [
    answers.skin_condition === 'not-sure' && 'You were not sure about the condition of the skin on that area.',
    answers.pregnant_breastfeeding === 'yes' && 'You are pregnant or breastfeeding.',
    answers.allergy_history === 'not-sure' && 'You were not sure whether you have reacted to these ingredients before.',
    answers.other_products === 'yes' && 'You plan to use other creams, gels or patches on the same area.'
  ].filter(Boolean);
  if (checkFirst.length) return { route: 'check-first', reasons: checkFirst };
  return { route: 'good-to-try', reasons: [] };
}

function offlineToolResult(slug, definition, answers) {
  const displayAnswer = (id, fallback) => {
    const question = definition.questions.find((item) => item.id === id);
    return answers[id] && question ? answerDisplay(question, answers[id]) : fallback;
  };
  const areaQuestion = definition.questions.find((question) => ['area', 'affected_area', 'pain_area'].includes(question.id));
  const area = areaQuestion && answers[areaQuestion.id] ? answerDisplay(areaQuestion, answers[areaQuestion.id]) : 'your routine';
  const intensity = answerDisplay(definition.questions.find((question) => question.id === 'intensity') || {}, answers.intensity || 'not supplied');
  const suitability = suitabilityRouteAndReasons(answers);
  const shared = {
    title: 'Your practical plan is ready.',
    route: ['9-10', 'sharp-pain', 'acute-pain', 'injury-risk'].some((value) => Object.values(answers).includes(value)) ? 'therapist' : 'product',
    whatYouToldUs: `You selected ${area.toLowerCase()} and described the intensity as ${intensity.toLowerCase()}. This offline preview uses the same structured report layout as the connected AI service, without sending or interpreting personal data.`,
    positiveSigns: 'Look for everyday movement becoming easier, less guarding around the area and a gradual return towards your normal range. Compare how the area feels across several check-ins rather than judging one moment.',
    escalationSignals: 'Pause the plan and seek qualified advice if symptoms are severe, worsening, persistent, follow an injury, include marked swelling or bruising, or involve numbness, weakness, chest pain or difficulty breathing.',
    muscleMint: 'If you choose to use Muscle Mint, apply a small amount to intact skin and massage it in as directed on the label. Expect a fresh cooling sensation. Wash your hands after use and keep it away from eyes and sensitive areas.',
    closing: 'Use this plan as a practical check-in, not a diagnosis. Adjust the next step to how normal movement feels today.',
    answers: toolAnswerSummary(definition, answers)
  };
  const plans = {
    'muscle-assessment': {
      summary: `Your answers point to a sensible next-step plan for ${area.toLowerCase()}, with the intensity and timing used to set the level of caution.`,
      pattern: 'Timing, intensity and the way the sensation behaves are more useful here than a label. Start with comfortable movement, then reassess before adding load.',
      steps: [
        { title: 'Set a comfortable baseline', target: area, duration: 'Two to five minutes', content: 'Move through an easy range without forcing the end position. Stop if the sensation becomes sharp or clearly worsens.' },
        { title: 'Use short movement breaks', target: area, duration: 'Every 60 to 90 minutes', content: 'Choose gentle walking or simple range-of-motion work. Short, repeatable bouts are easier to judge than one long session.' },
        { title: 'Make the next load smaller', target: area, duration: 'For the next session', content: 'Reduce the movement, volume or effort that seems connected, then build back gradually if normal movement remains comfortable.' },
        { title: 'Review the trend', target: area, duration: 'Later today and tomorrow', content: 'Note whether ordinary movement is easier, unchanged or worse. Use that trend to decide whether to progress or seek advice.' }
      ]
    },
    'doms-calculator': {
      summary: `Your timing, training type and ${intensity.toLowerCase()} intensity create a practical recovery window rather than an exact prediction.`,
      pattern: 'Delayed soreness commonly becomes noticeable after unfamiliar or demanding training. The useful measure is whether it follows a steady improving trend over the next few days.',
      steps: [
        { title: 'Keep recovery active', target: area, duration: 'Ten to twenty easy minutes', content: 'Use walking, easy cycling or comfortable mobility. Keep the effort low enough that the area feels the same or easier afterwards.' },
        { title: 'Protect the next hard session', target: area, duration: 'Until movement feels close to normal', content: 'Avoid repeating the same hard loading while the area is still markedly tender or restricted.' },
        { title: 'Support the basics', target: 'Whole routine', duration: 'Today and tonight', content: 'Prioritise regular meals, fluids and a normal sleep opportunity. These give the result context without promising an exact recovery time.' },
        { title: 'Check the direction', target: area, duration: 'Once or twice daily', content: 'A useful pattern is stable or improving movement. Seek advice if the pattern is worsening, unusually severe or not behaving like your normal post-training soreness.' }
      ]
    },
    'posture-check': {
      summary: `Your desk pattern suggests starting with changes you can repeat during the working day, especially around ${area.toLowerCase()}.`,
      pattern: 'A single perfect posture is less useful than changing position regularly. Screen, seat and task setup should reduce the need to hold one strained position for long periods.',
      steps: [
        { title: 'Reset the workstation', target: 'Screen, chair and input devices', duration: 'Two minutes', content: 'Bring frequently used items within easy reach, support your feet and place the screen where you can look ahead without craning.' },
        { title: 'Change position often', target: area, duration: 'One to two minutes every 30 to 60 minutes', content: 'Stand, walk or move the area through a comfortable range. Variety matters more than holding a rigid pose.' },
        { title: 'Choose one repeatable drill', target: area, duration: 'Five slow repetitions', content: 'Use a movement that feels easy, such as shoulder rolls, gentle trunk turns or standing hip extension. Keep it within a comfortable range.' },
        { title: 'Review the workday pattern', target: 'Your normal working day', duration: 'At the end of the day', content: 'Note which task or time block is most connected. That gives you one practical setup or timing change to test tomorrow.' }
      ]
    },
    'recovery-planner': {
      summary: 'Your plan uses training frequency, sleep and the main recovery challenge to create a routine you can actually repeat.',
      whatYouToldUs: `You train ${displayAnswer('training_days_per_week', 'several days')} each week, described your recent sleep as ${displayAnswer('sleep_quality', 'not supplied').toLowerCase()} and selected ${displayAnswer('recovery_challenge', 'general recovery').toLowerCase()} as the main challenge.`,
      pattern: 'A useful recovery plan protects demanding sessions, leaves room for easier days and treats sleep and workload as part of training rather than an afterthought.',
      positiveSigns: 'Look for steadier energy between sessions, fewer days when normal movement feels restricted and more consistency in session quality. Review the weekly trend rather than reacting to one difficult day.',
      steps: [
        { title: 'Mark the demanding days', target: 'Your weekly schedule', duration: 'Once each week', content: 'Identify the sessions with the highest load and avoid stacking every demanding day together when your schedule allows.' },
        { title: 'Give easy days a job', target: 'Between hard sessions', duration: 'Ten to twenty easy minutes', content: 'Use light movement, technique work or a walk. An easy day should leave you feeling ready, not add another hard session.' },
        { title: 'Build a short evening reset', target: 'Sleep routine', duration: 'Thirty to sixty minutes before bed', content: 'Reduce stimulating work, prepare tomorrow early and keep the routine consistent enough to notice whether sleep quality changes.' },
        { title: 'Review one signal', target: 'Performance and daily energy', duration: 'Once each week', content: 'Track one useful measure such as session quality, motivation or morning energy. If it trends down, reduce load before adding more recovery tactics.' }
      ]
    },
    'suitability-check': {
      title: suitability.route === 'good-to-try' ? 'Nothing in your answers suggests a problem.' : suitability.route === 'check-first' ? 'It is worth a quick word with a pharmacist before you use this.' : 'This is not one for you, at least not for that area or right now.',
      route: suitability.route,
      reasons: suitability.reasons,
      summary: suitability.route === 'good-to-try' ? 'Nothing in your answers suggests a problem.' : suitability.route === 'check-first' ? 'It is worth a quick word with a pharmacist before you use this.' : 'This is not one for you, at least not for that area or right now.',
      muscleMint: suitability.route === 'good-to-try' ? 'If you choose to use Muscle Mint, apply a small amount to intact skin and massage it in as directed on the label. Wash your hands after use and keep it away from eyes and sensitive areas.' : '',
      steps: suitability.route === 'good-to-try' ? [
        { title: 'Patch test first', target: 'Inside of the forearm', duration: answers.used_menthol_before === 'no' ? 'Wait 24 hours before using more' : 'Optional refresher', content: answers.used_menthol_before === 'no' ? 'You have not used a strong menthol product before, so try a small amount on the inside of the forearm and wait 24 hours before using more.' : 'A small amount on the inside of the forearm remains a sensible first check, even with past use.' },
        { title: 'Use it on intact skin only', target: displayAnswer('use_area', 'the area you chose'), duration: 'Every use', content: 'Keep it to unbroken, healthy skin in the area you selected.' },
        { title: 'Wash your hands afterwards', target: 'Hands and face', duration: 'Every use', content: 'Wash your hands after applying it and keep it away from your eyes.' },
        { title: 'Read the full directions', target: 'Directions and safety page', duration: 'Before first use', content: 'The product label and the directions and safety page cover full application guidance.' }
      ] : suitability.route === 'check-first' ? [
        { title: 'Ask a pharmacist first', target: 'Local pharmacist', duration: 'Before you use it', content: 'Describe your answers above and ask whether this product is suitable for you right now.' },
        { title: 'Bring the ingredient list', target: 'Product packaging', duration: 'To the conversation', content: 'Having the label to hand makes it easier for a pharmacist to give you a clear answer.' },
        { title: 'Hold off until you have asked', target: 'This area', duration: 'Meanwhile', content: 'Wait until you have spoken to a pharmacist or GP before applying it.' }
      ] : [
        { title: 'Choose a different area or time', target: 'This use', duration: 'For now', content: 'Based on your answers, this is not the right area or time to use this product.' },
        { title: 'Speak to a pharmacist or GP', target: 'Local pharmacist or GP', duration: 'For a red flag such as broken skin or a reaction history', content: 'Ask them whether a product like this is appropriate for you.' },
        { title: 'Read the directions and safety page', target: 'Directions and safety page', duration: 'Any time', content: 'It sets out who this product is and is not suitable for.' }
      ]
    }
  };
  return { ...shared, ...(plans[slug] || plans['muscle-assessment']) };
}

function normaliseToolResult(raw, slug, definition, answers) {
  const fallback = offlineToolResult(slug, definition, answers);
  if (!raw || typeof raw !== 'object') return fallback;
  const steps = raw.recovery_steps || raw.section3_recovery_protocol || raw.steps || [];
  const allowedRoutes = definition.routes || ['product', 'therapist'];
  return {
    title: raw.title || fallback.title,
    summary: raw.summary || raw.section1_what_you_told_me || fallback.summary,
    route: allowedRoutes.includes(raw.route) ? raw.route : allowedRoutes[0],
    reasons: raw.reasons || fallback.reasons || [],
    whatYouToldUs: raw.section1_what_you_told_me || raw.what_you_told_me || fallback.whatYouToldUs,
    pattern: raw.section2_clinical_assessment || raw.pattern || raw.why_this_recommendation || fallback.pattern,
    steps: (steps.length ? steps : fallback.steps).map((step, index) => ({
      step: step.step || index + 1,
      title: step.title || `Step ${index + 1}`,
      content: step.content || step.technique || '',
      target: step.target || '',
      duration: step.duration_frequency || '',
      rationale: step.rationale || ''
    })),
    muscleMint: raw.section4_muscle_mint || raw.recommendation || fallback.muscleMint,
    positiveSigns: raw.section5_positive_signs || fallback.positiveSigns,
    escalationSignals: raw.section5_escalation_signals || fallback.escalationSignals,
    closing: raw.section6_closing_note || raw.closing || raw.zolene_note || fallback.closing,
    answers: toolAnswerSummary(definition, answers)
  };
}

function toolApiBase(section) {
  return String(section?.dataset.toolApiBase || window.MuscleMintToolsConfig?.apiBase || 'https://admin.musclemint.co/api').replace(/\/$/, '');
}

async function submitToolToApi(slug, definition, answers, apiBase) {
  if (isLocalToolPreview()) {
    await new Promise((resolve) => setTimeout(resolve, 220));
    return { success: true, data: { submission_id: `offline-${slug}`, basic_result: offlineToolResult(slug, definition, answers), status: 'offline' } };
  }
  const params = new URLSearchParams(window.location.search);
  const response = await fetch(`${apiBase}/free-tools/submit`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Tool-Session-Id': crypto.randomUUID?.() || String(Date.now()) },
    body: JSON.stringify({
      tool_slug: slug,
      tool_name: definition.name,
      answers,
      first_name: '',
      honeypot: '',
      utm_source: params.get('utm_source') || undefined,
      utm_medium: params.get('utm_medium') || undefined,
      utm_campaign: params.get('utm_campaign') || undefined,
      utm_content: params.get('utm_content') || undefined,
      referrer: document.referrer || undefined
    })
  });
  if (!response.ok) throw new Error('We could not save this check-in. Your answers are still here.');
  return response.json();
}

async function requestToolReport(apiBase, submissionId) {
  const response = await fetch(`${apiBase}/free-tools/result/${encodeURIComponent(submissionId)}`, { headers: { Accept: 'application/json' } });
  if (!response.ok) throw new Error('Result unavailable');
  return response.json();
}

async function emailToolReport(apiBase, submissionId, slug, email) {
  const response = await fetch(`${apiBase}/free-tools/email-signup`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ submission_id: submissionId, tool_slug: slug, email, gdpr_consent: true })
  });
  if (!response.ok) throw new Error('Email delivery could not be arranged');
  return response.json();
}

async function rateToolResult(apiBase, submissionId, slug, definition, score) {
  return fetch(`${apiBase}/free-tools/rating`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ submission_id: submissionId, tool_slug: slug, tool_name: definition.name, rating: score })
  });
}

async function trackToolShare(apiBase, submissionId) {
  return fetch(`${apiBase}/free-tools/share`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ submission_id: submissionId, platform: 'copy_link' })
  });
}

async function prepareFreeToolLibrary(root = document) {
  const library = root.querySelector('[data-free-tool-library]');
  if (!library || library.dataset.ready) return;
  library.dataset.ready = 'true';
  const cards = [...library.querySelectorAll('[data-tool-card]')];
  if (!cards.length) return;
  const settle = (card, countText, ratingText) => {
    const count = card.querySelector('[data-tool-stat-count]');
    const rating = card.querySelector('[data-tool-stat-rating]');
    if (count) count.textContent = countText;
    if (rating) rating.textContent = ratingText;
  };
  try {
    const response = await fetch(`${toolApiBase(library)}/free-tools/stats`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Stats unavailable');
    const payload = await response.json();
    cards.forEach((card) => {
      const slug = card.dataset.toolCard;
      const uses = Number(payload?.stats?.[slug]?.count || 0);
      const rating = payload?.ratings?.[slug];
      const countText = uses === 0 ? 'New tool' : `${uses.toLocaleString('en-GB')} ${uses === 1 ? 'check-in' : 'check-ins'}`;
      const ratingText = rating?.total_ratings ? `${Number(rating.avg_rating).toFixed(1)} / 5` : 'Not rated yet';
      settle(card, countText, ratingText);
    });
  } catch { /* Keep the last verified snapshot visible in the offline build. */ }
}

function prepareFreeTools(root = document) {
  root.querySelectorAll('[data-free-tool]').forEach((section) => {
    if (section.dataset.ready) return;
    const slug = section.dataset.toolSlug;
    const definition = freeToolDefinitions[slug];
    const app = section.querySelector('[data-tool-app]');
    if (!definition || !app) return;
    section.dataset.ready = 'true';

    const apiBase = toolApiBase(section);
    const state = { phase: 'intro', currentId: definition.questions[0].id, visitStack: [], answers: {}, transitionToken: 0, locked: false, result: null, submissionId: null, reportStatus: 'idle', emailCaptured: false, emailAddress: '', polling: false };
    const live = createToolElement('p', 'tool-status visually-hidden', '');
    live.setAttribute('role', 'status');
    live.setAttribute('aria-live', 'polite');

    const announce = (message) => { live.textContent = ''; requestAnimationFrame(() => { live.textContent = message; }); };
    const focusPanel = () => requestAnimationFrame(() => app.querySelector('[data-tool-focus]')?.focus());
    const emit = (name, detail = {}) => section.dispatchEvent(new CustomEvent(`musclemint:tool-${name}`, { bubbles: true, detail: { slug, ...detail } }));

    const mount = (panel, shouldFocus = true) => {
      app.removeAttribute('aria-busy');
      app.replaceChildren(panel, live);
      if (shouldFocus) focusPanel();
    };

    const addBack = (container, label = 'Back') => {
      const button = createToolElement('button', 'tool-back', `← ${label}`);
      button.type = 'button';
      button.addEventListener('click', () => {
        state.transitionToken += 1;
        state.locked = false;
        const previous = state.visitStack.pop();
        if (previous) { state.currentId = previous; renderQuestion(); }
        else renderIntro();
      });
      container.append(button);
    };

    const goNext = async (token = state.transitionToken) => {
      if (token !== state.transitionToken) return;
      const index = definition.questions.findIndex((question) => question.id === state.currentId);
      if (index < definition.questions.length - 1) {
        state.visitStack.push(state.currentId);
        state.currentId = definition.questions[index + 1].id;
        state.locked = false;
        renderQuestion();
        return;
      }
      await submitAnswers();
    };

    const renderIntro = () => {
      state.phase = 'intro';
      const panel = createToolElement('div', 'tool-start');
      const eyebrow = createToolElement('p', 'eyebrow', isLocalToolPreview() ? 'Offline safe preview' : 'Free interactive tool');
      const heading = createToolElement('h3', '', 'Ready when you are.');
      heading.tabIndex = -1; heading.dataset.toolFocus = '';
      const copy = createToolElement('p', '', `Work through ${definition.questions.length} short questions. Your result appears on this page.`);
      const button = createToolElement('button', 'button', `Start ${definition.name}`);
      button.type = 'button';
      button.addEventListener('click', () => { state.phase = 'question'; state.currentId = definition.questions[0].id; state.visitStack = []; renderQuestion(); });
      panel.append(eyebrow, heading, copy, button);
      mount(panel, false);
    };

    const renderQuestion = () => {
      state.phase = 'question';
      // Always unlock on (re)entry: covers returning via the error screen's
      // "Review last answer", where the transition lock was never cleared.
      state.locked = false;
      const index = definition.questions.findIndex((question) => question.id === state.currentId);
      const question = definition.questions[index];
      const panel = createToolElement('div', 'tool-question');
      const progressWrap = createToolElement('div', 'tool-progress');
      const progress = document.createElement('progress');
      progress.max = definition.questions.length; progress.value = index + 1;
      progress.setAttribute('aria-label', `Question ${index + 1} of ${definition.questions.length}`);
      const count = createToolElement('small', '', `${String(index + 1).padStart(2, '0')} / ${String(definition.questions.length).padStart(2, '0')}`);
      progressWrap.append(progress, count);
      const eyebrow = createToolElement('p', 'eyebrow', question.required ? `Question ${index + 1}` : `Question ${index + 1} · Optional`);
      const heading = createToolElement('h3', '', question.prompt);
      heading.id = `tool-question-${slug}-${question.id}`; heading.tabIndex = -1; heading.dataset.toolFocus = '';
      const form = createToolElement('form', 'tool-question__form');
      form.setAttribute('aria-labelledby', heading.id);

      if (question.type === 'choice') {
        const fieldset = createToolElement('fieldset', 'tool-options');
        const legend = createToolElement('legend', 'visually-hidden', question.prompt);
        fieldset.append(legend);
        question.options.forEach(([value, labelText]) => {
          const label = createToolElement('label', 'tool-option');
          const input = document.createElement('input');
          input.type = 'radio'; input.name = question.id; input.value = value; input.checked = state.answers[question.id] === value;
          const labelCopy = createToolElement('span', '', labelText);
          const select = () => {
            if (state.locked) return;
            state.answers[question.id] = value;
            state.locked = true;
            fieldset.querySelectorAll('input').forEach((item) => { item.disabled = true; });
            announce('Answer selected. Moving to the next question.');
            const token = ++state.transitionToken;
            setTimeout(() => goNext(token), 250);
          };
          // 'change' covers keyboard arrow selection; 'click' covers re-selecting an
          // already-checked option after going back (no change event fires then).
          // The state.locked guard stops the pair double-firing on a fresh pick.
          input.addEventListener('change', select);
          input.addEventListener('click', select);
          label.append(input, labelCopy); fieldset.append(label);
        });
        form.append(fieldset);
      } else {
        const label = createToolElement('label', 'visually-hidden', question.prompt);
        label.htmlFor = `tool-input-${slug}-${question.id}`;
        const input = document.createElement('input');
        input.id = label.htmlFor; input.name = question.id; input.type = question.type === 'date' ? 'date' : 'text';
        input.value = state.answers[question.id] || ''; input.required = question.required;
        input.autocomplete = 'off'; input.className = 'tool-text-input';
        const actions = createToolElement('div', 'tool-actions');
        const continueButton = createToolElement('button', 'button', index === definition.questions.length - 1 ? 'See my result' : 'Continue');
        continueButton.type = 'submit';
        actions.append(continueButton);
        if (!question.required) {
          const skip = createToolElement('button', 'tool-skip', 'Skip this question');
          skip.type = 'button'; skip.addEventListener('click', () => { delete state.answers[question.id]; goNext(); });
          actions.prepend(skip);
        }
        form.append(label, input, actions);
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          const value = input.value.trim();
          if (question.required && !value) { input.reportValidity(); return; }
          if (value) state.answers[question.id] = value; else delete state.answers[question.id];
          goNext();
        });
      }

      const nav = createToolElement('div', 'tool-question__back');
      addBack(nav, index ? 'Previous question' : 'Introduction');
      panel.append(progressWrap, eyebrow, heading, form, nav);
      mount(panel);
    };

    const submitAnswers = async () => {
      state.phase = 'submitting'; app.setAttribute('aria-busy', 'true');
      const panel = createToolElement('div', 'tool-loading');
      const heading = createToolElement('h3', '', 'Preparing your result…'); heading.tabIndex = -1; heading.dataset.toolFocus = '';
      panel.append(heading, createToolElement('p', '', isLocalToolPreview() ? 'Using a safe offline fixture. No data is being sent.' : 'Saving your answers securely.'));
      mount(panel); app.setAttribute('aria-busy', 'true');
      try {
        const payload = await submitToolToApi(slug, definition, state.answers, apiBase);
        const data = payload?.data || payload || {};
        state.submissionId = data.submission_id || null;
        state.serverCta = { productUrl: data.product_url || '', therapistUrl: data.therapist_url || '', discountCode: data.discount_code || '' };
        state.result = normaliseToolResult(data.basic_result, slug, definition, state.answers);
        if (definition.ai === false) {
          state.reportStatus = 'ready';
          renderFullResult(false);
        } else {
          state.reportStatus = isLocalToolPreview() ? 'offline' : 'processing';
          renderPreview();
        }
      } catch { renderError('We could not save this check-in. Your answers are still here.'); }
    };

    const renderError = (message) => {
      state.phase = 'error';
      const panel = createToolElement('div', 'tool-error');
      const heading = createToolElement('h3', '', 'Your answers are still here.'); heading.tabIndex = -1; heading.dataset.toolFocus = '';
      const copy = createToolElement('p', '', message || 'The service did not respond.');
      const actions = createToolElement('div', 'tool-actions');
      const retry = createToolElement('button', 'button', 'Try again'); retry.type = 'button'; retry.addEventListener('click', submitAnswers);
      const back = createToolElement('button', 'tool-back', '← Review last answer'); back.type = 'button'; back.addEventListener('click', renderQuestion);
      actions.append(back, retry); panel.append(heading, copy, actions); mount(panel);
    };

    const renderPreview = () => {
      state.phase = 'preview';
      const panel = createToolElement('div', 'tool-result tool-result--preview');
      const tag = createToolElement('p', 'eyebrow', isLocalToolPreview() ? 'Offline fixture preview' : 'Your result preview');
      const heading = createToolElement('h3', '', state.result.title); heading.tabIndex = -1; heading.dataset.toolFocus = '';
      const copy = createToolElement('p', '', state.result.summary);
      const actions = createToolElement('div', 'tool-preview-actions');
      const skip = createToolElement('button', 'tool-skip tool-skip--prominent', 'Skip and see full results now'); skip.type = 'button'; skip.addEventListener('click', renderFullResult);
      actions.append(buildEmailForm(), skip); panel.append(tag, heading, copy, actions); mount(panel);
    };

    const buildEmailForm = () => {
      const form = createToolElement('form', 'tool-email');
      const heading = createToolElement('h4', '', 'Keep a copy for later');
      const copy = createToolElement('p', '', isLocalToolPreview()
        ? 'In the connected version, your personalised report and branded PDF can be sent here. This offline preview does not send or store data.'
        : 'Enter your email to receive the finished report and a branded PDF. You can still see the full result on this page without entering it.');
      const row = createToolElement('div', 'tool-email__row');
      const label = createToolElement('label', 'visually-hidden', 'Email address');
      const input = document.createElement('input'); input.id = `tool-email-${slug}`; input.name = 'email'; input.type = 'email'; input.autocomplete = 'email'; input.placeholder = 'Email address'; input.required = true; label.htmlFor = input.id;
      const button = createToolElement('button', 'button', 'Email my report'); button.type = 'submit';
      row.append(label, input, button);
      const privacy = createToolElement('p', 'tool-consent', 'Used only to deliver this report. Marketing permission is separate and is not added automatically.');
      const status = createToolElement('p', 'tool-status', ''); status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite');
      form.append(heading, copy, row, privacy, status);
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!input.reportValidity()) return;
        button.disabled = true;
        status.textContent = isLocalToolPreview() ? 'Offline preview only. Nothing was sent or stored.' : 'Arranging your report copy…';
        if (isLocalToolPreview()) {
          state.emailCaptured = true;
          state.emailAddress = input.value.trim();
          emit('email-preview');
          renderFullResult(false);
          return;
        }
        try {
          await emailToolReport(apiBase, state.submissionId, slug, input.value.trim());
          state.emailCaptured = true;
          state.emailAddress = input.value.trim();
          emit('email-requested');
          renderFullResult();
        } catch {
          button.disabled = false;
          status.textContent = 'We could not arrange the email copy. You can still see the full result now.';
        }
      });
      return form;
    };

    const appendReportSection = (panel, title, sectionCopy, className = '') => {
      if (!sectionCopy) return;
      const sectionBlock = createToolElement('section', `tool-report-section ${className}`.trim());
      sectionBlock.append(createToolElement('h4', '', title), createToolElement('p', '', sectionCopy));
      panel.append(sectionBlock);
    };

    const pollForAiResult = async () => {
      if (isLocalToolPreview() || !state.submissionId || state.polling || state.reportStatus === 'ready') return;
      state.polling = true;
      for (let attempt = 0; attempt < 15; attempt += 1) {
        try {
          const payload = await requestToolReport(apiBase, state.submissionId);
          const data = payload?.data || {};
          if (data.status === 'ready' && data.ai_result) {
            state.result = normaliseToolResult(data.ai_result, slug, definition, state.answers);
            state.reportStatus = 'ready';
            state.polling = false;
            if (state.phase === 'result') renderFullResult(false);
            announce('Your personalised report is ready.');
            return;
          }
          if (data.status === 'failed') break;
        } catch { /* Keep the useful immediate result visible. */ }
        await new Promise((resolve) => setTimeout(resolve, 2000));
      }
      state.polling = false;
      const status = app.querySelector('[data-report-status]');
      if (status) status.textContent = 'Your immediate plan is shown below. The personalised report is still being prepared.';
    };

    const renderFullResult = (startPolling = true) => {
      state.phase = 'result';
      const panel = createToolElement('div', 'tool-result');
      if (state.emailCaptured) {
        const confirmation = createToolElement('aside', 'tool-email-confirmation');
        confirmation.setAttribute('role', 'status');
        const icon = createToolElement('span', 'tool-email-confirmation__icon');
        icon.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 6h16v12H4z"></path><path d="m4 7 8 6 8-6"></path></svg>';
        const message = createToolElement('div', '');
        const deliveryHeading = createToolElement('h4', '', 'Your extended report has been requested.');
        const address = state.emailAddress ? ` to ${state.emailAddress}` : '';
        const deliveryCopy = createToolElement('p', '', isLocalToolPreview()
          ? `Offline preview: this is the confirmation shown after requesting delivery${address}. The connected store will email the detailed PDF when it is ready. If it does not appear in the inbox, the visitor should check the spam or junk folder.`
          : `Your short report is ready below. We are preparing the extended PDF and will email it${address} soon. If it does not appear in your inbox, please check your spam or junk folder.`);
        message.append(deliveryHeading, deliveryCopy);
        confirmation.append(icon, message);
        panel.append(confirmation);
      }
      const tag = createToolElement('p', 'eyebrow', isLocalToolPreview() ? 'Offline fixture result' : 'Your educational result');
      const heading = createToolElement('h3', '', state.result.title); heading.tabIndex = -1; heading.dataset.toolFocus = '';
      const copy = createToolElement('p', '', state.result.summary);
      panel.append(tag, heading, copy);
      if ((state.result.reasons || []).length) {
        const reasonsList = createToolElement('ul', 'tool-result__reasons');
        state.result.reasons.forEach((reason) => reasonsList.append(createToolElement('li', '', reason)));
        panel.append(reasonsList);
      }
      if (definition.ai !== false) {
        const reportStatus = createToolElement('p', 'tool-report-status', state.reportStatus === 'ready'
          ? 'Personalised analysis complete.'
          : isLocalToolPreview() ? 'Useful offline fixture. No information has been sent.' : state.emailCaptured ? 'Your short plan is ready. The extended report is being prepared.' : 'Your immediate plan is ready. Personalised analysis is being prepared.');
        reportStatus.dataset.reportStatus = '';
        panel.append(reportStatus);
        appendReportSection(panel, 'What your answers show', state.result.whatYouToldUs);
        appendReportSection(panel, 'What the pattern suggests', state.result.pattern);
      }

      const actionHeading = createToolElement('h4', '', 'Your practical plan');
      const list = createToolElement('ol', 'tool-result__steps');
      (state.result.steps || []).forEach((step) => {
        const item = createToolElement('li', 'tool-result-step');
        const stepTop = createToolElement('div', 'tool-result-step__top');
        stepTop.append(createToolElement('span', 'tool-result-step__number', String(step.step || list.children.length + 1)), createToolElement('h5', '', step.title));
        item.append(stepTop);
        if (step.target || step.duration) item.append(createToolElement('p', 'tool-result-step__meta', [step.target, step.duration].filter(Boolean).join(' · ')));
        if (step.content) item.append(createToolElement('p', '', step.content));
        if (step.rationale) item.append(createToolElement('p', 'tool-result-step__why', step.rationale));
        list.append(item);
      });
      panel.append(actionHeading, list);
      if (definition.ai !== false) {
        appendReportSection(panel, 'Signs the plan is moving in the right direction', state.result.positiveSigns, 'tool-report-section--positive');
        appendReportSection(panel, 'When to pause and seek qualified advice', state.result.escalationSignals, 'tool-report-section--caution');
      }
      // Custom-route tools (definition.routes) only get product framing on the route that
      // permits a product link. On the other routes the copy is a referral away from the
      // product, so it still renders, under a neutral heading and without product styling.
      const productSectionAllowed = definition.routes ? state.result.route === 'good-to-try' : true;
      appendReportSection(
        panel,
        productSectionAllowed ? 'Where Muscle Mint can fit' : 'What to do next',
        state.result.muscleMint,
        productSectionAllowed ? 'tool-report-section--product' : ''
      );
      appendReportSection(panel, 'Your next check-in', state.result.closing);

      const answerDetails = createToolElement('details', 'tool-answer-details');
      answerDetails.append(createToolElement('summary', '', 'Review the answers used for this report'));
      const answers = createToolElement('dl', 'tool-answer-summary');
      state.result.answers.forEach(([term, value]) => { answers.append(createToolElement('dt', '', term), createToolElement('dd', '', value)); });
      answerDetails.append(answers);
      const disclaimer = createToolElement('p', 'tool-result__caution', definition.disclaimer || `${slug === 'doms-calculator' ? 'This calculator' : slug === 'recovery-planner' ? 'This tool' : 'This assessment'} provides estimates based on general recovery patterns. Individual recovery times may vary. Consult a healthcare professional for persistent or severe pain.`);
      panel.append(answerDetails, disclaimer);
      // Custom-route tools resolve their own CTA: only 'good-to-try' may link to the product.
      // The other routes link to the safety page, or render no CTA at all if none is configured.
      // Tools without definition.routes keep the original product/therapist CTA behaviour,
      // where a blank product_label still retires the CTA entirely.
      let ctaHref = '';
      let ctaLabel = '';
      if (definition.routes) {
        if (state.result.route === 'good-to-try' && section.dataset.toolProductLabel) {
          // Label and destination must agree: the product CTA appears only when a
          // product label is configured, otherwise good-to-try uses the safety page too.
          ctaHref = state.serverCta?.productUrl || section.dataset.toolProductUrl || '';
          ctaLabel = section.dataset.toolProductLabel;
        } else {
          ctaHref = section.dataset.toolSafetyUrl || '';
          ctaLabel = section.dataset.toolSafetyLabel || '';
        }
      } else {
        ctaHref = state.result.route === 'therapist' ? (state.serverCta?.therapistUrl || section.dataset.toolSupportUrl) : (state.serverCta?.productUrl || section.dataset.toolProductUrl);
        ctaLabel = state.result.route === 'therapist' ? section.dataset.toolSupportLabel : section.dataset.toolProductLabel;
      }
      // Both are required: a configured URL with no label would render a button
      // with no accessible name, and a label with no URL renders nothing useful.
      if (ctaHref && ctaLabel) {
        const cta = createToolElement('a', 'button tool-result__cta', ctaLabel);
        cta.href = ctaHref;
        cta.addEventListener('click', () => emit('cta', { route: state.result.route }));
        panel.append(cta);
      }
      if (definition.ai !== false && !state.emailCaptured) panel.append(buildEmailForm());

      const utilities = createToolElement('div', 'tool-result__utilities');
      const share = createToolElement('button', 'tool-secondary', 'Share this tool'); share.type = 'button';
      const utilityStatus = createToolElement('p', 'tool-status', ''); utilityStatus.setAttribute('role', 'status');
      share.addEventListener('click', async () => {
        try {
          if (navigator.share) await navigator.share({ title: definition.name, url: window.location.href });
          else { await navigator.clipboard.writeText(window.location.href); utilityStatus.textContent = 'Tool link copied.'; }
          if (!isLocalToolPreview() && state.submissionId) await trackToolShare(apiBase, state.submissionId);
          emit('share', { submissionId: state.submissionId });
        } catch { utilityStatus.textContent = 'Sharing was cancelled. No answer data was shared.'; }
      });
      const rating = createToolElement('fieldset', 'tool-rating'); rating.append(createToolElement('legend', '', 'Was this tool useful?'));
      for (let score = 1; score <= 5; score += 1) {
        const button = createToolElement('button', 'tool-rating__button', String(score)); button.type = 'button'; button.setAttribute('aria-label', `${score} out of 5`);
        button.addEventListener('click', async () => {
          emit('rating', { score, submissionId: state.submissionId });
          if (isLocalToolPreview()) { utilityStatus.textContent = 'Offline preview: your rating was not sent.'; return; }
          try {
            const response = await rateToolResult(apiBase, state.submissionId, slug, definition, score);
            utilityStatus.textContent = response.ok ? 'Thank you. Your rating has been noted.' : 'We could not save that rating.';
          } catch { utilityStatus.textContent = 'We could not save that rating.'; }
        });
        rating.append(button);
      }
      const restart = createToolElement('button', 'tool-restart', 'Start again'); restart.type = 'button'; restart.addEventListener('click', () => { state.answers = {}; state.visitStack = []; state.result = null; state.submissionId = null; state.reportStatus = 'idle'; state.emailCaptured = false; state.emailAddress = ''; emit('restart'); renderIntro(); });
      utilities.append(share, rating, restart, utilityStatus);
      panel.append(utilities); mount(panel);
      if (startPolling && definition.ai !== false) pollForAiResult();
    };

    renderIntro();
  });
}

prepareFreeToolLibrary(document);
prepareFreeTools(document);
document.addEventListener('shopify:section:load', (event) => {
  prepareFreeToolLibrary(event.target);
  prepareFreeTools(event.target);
});
})();
